// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "control-3Fcg3";
var _4 = "label-3CzpO";
var _5 = "checkbox-3xuK8";
var _6 = "checkbox_checked-2dkE1";
var _7 = "popper-1liqm";
export { _1 as "__esModule", _2 as "mobile", _3 as "control", _4 as "label", _5 as "checkbox", _6 as "checkbox_checked", _7 as "popper" }
export default { "__esModule": _1, "mobile": _2, "control": _3, "label": _4, "checkbox": _5, "checkbox_checked": _6, "popper": _7 }
